import { ActorRefFrom, createActor } from 'xstate';

import { navigationMachine } from '~/_v3/common/machines/navigation.machine';

export let navigationService: ActorRefFrom<typeof navigationMachine>;

export function startNavigationService() {
	navigationService = createActor(navigationMachine);
	navigationService.start();

	return navigationService;
}

export function stopNavigationService() {
	if (navigationService) {
		navigationService.stop();
	}
}
